import { render, staticRenderFns } from "./CrearProcedimientosDerivados.vue?vue&type=template&id=5cc0e68f"
import script from "./CrearProcedimientosDerivados.vue?vue&type=script&lang=js"
export * from "./CrearProcedimientosDerivados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports